import Hero from "./Hero";
import "../App.css";
import Lottie from "lottie-react";
import planning from "../assets/multipleperson_work_dashboard.json";
import design from "../assets/designing.json";
import development from "../assets/devlopment_code.json";
import testing from "../assets/bulb_person.json";
import launch from "../assets/launch.json";
import maintain from "../assets/work_to_gather_grwoth.json";
import img1 from "../assets/webdev.png";
import img2 from "../assets/uiuxdev.png";
import img3 from "../assets/shopify.png";
import img4 from "../assets/designing.png";
import img5 from "../assets/marketing.png";
import FancyButton from "./Button";
import 'aos/dist/aos.css';
import { useEffect } from "react";
import TestimonialCarousel from "./TestimonialCarousel";
import AOS from 'aos'
import { Link, Navigate } from "react-router-dom";
import { useState } from "react";
import SEO from "../components/SEO";

const Home = () => {

    const [email, setEmail] = useState("");
    const [subscribeSuccessMsg, setSubscribeSuccessMsg] = useState("");

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/subscribe`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email }),
            });

            if (res.ok) {
                setSubscribeSuccessMsg("✅ Subscribed! Check your inbox 📧");
                setEmail("");
            } else {
                setSubscribeSuccessMsg("❌ Something went wrong. Please try again.");
            }
        } catch (err) {
            console.error("Frontend Error:", err);
            setSubscribeSuccessMsg("❌ Failed to connect to the server.");
        }
    };

    useEffect(() => {
        AOS.init({
            duration: 2000, // 2 seconds
            once: false,     // only animate once
        });
    }, []);

    const data = [
        {
            title: "Web Development",
            desc: (
                <>
                    <p className="mb-2 font-inter">
                        We offer responsive and SEO-optimized web development services using cutting-edge technologies:
                    </p>
                    <ul className="list-disc pl-5 space-y-1 text-left font-inter">
                        <li>Built with React, Next.js for fast, modern web apps</li>
                        <li>SEO best practices: clean URLs, meta tags, and structured data</li>
                        <li>Mobile-first responsive design for cross-device compatibility</li>
                        <li>Fast load times and code splitting for better performance</li>
                        <li>Custom dashboards and CMS integration for easy content updates</li>
                    </ul>
                </>
            ),
            image: img1,
            button: "See What We Do"
        },
        {
            title: "Creative UI/UX",
            desc: (
                <>
                    <p className="mb-2 font-inter">
                        We focus on crafting engaging and accessible digital experiences:
                    </p>
                    <ul className="list-disc pl-5 space-y-1 text-left font-inter">
                        <li>User-centric wireframes and prototypes</li>
                        <li>Interactive Figma designs with clear user flow</li>
                        <li>WCAG-compliant accessible layouts</li>
                        <li>Optimized for higher conversions and retention</li>
                        <li>Cross-platform UI consistency for web & mobile</li>
                    </ul>
                </>
            ),
            image: img2,
            button: "See What We Do"
        },
        {
            title: "Shopify Store",
            desc: (
                <>
                    <p className="mb-2 font-inter">
                        We help launch and scale your eCommerce business using Shopify:
                    </p>
                    <ul className="list-disc pl-5 space-y-1 text-left font-inter">
                        <li>Custom Shopify theme development</li>
                        <li>Product and collection page optimization</li>
                        <li>SEO-ready structure and fast performance</li>
                        <li>Payment gateway & shipping integration</li>
                        <li>Inventory, analytics, and app integrations</li>
                    </ul>
                </>
            ),
            image: img3,
            button: "See What We Do"
        },
        {
            title: "Graphics Design",
            desc: (
                <>
                    <p className="mb-2 font-inter">
                        Visually compelling graphics to elevate your brand identity:
                    </p>
                    <ul className="list-disc pl-5 space-y-1 text-left font-inter">
                        <li>Logo, banner, brochure & packaging design</li>
                        <li>Brand style guides for consistency</li>
                        <li>Social media and ad creatives</li>
                        <li>Print and digital design assets</li>
                        <li>Use of tools like Adobe Illustrator, Photoshop, Canva</li>
                    </ul>
                </>
            ),
            image: img4,
            button: "See What We Do"
        },
        {
            title: "Digital Marketing",
            desc: (
                <>
                    <p className="mb-2 font-inter">
                        Strategies to grow your online presence and maximize ROI:
                    </p>
                    <ul className="list-disc pl-5 space-y-1 text-left font-inter">
                        <li>Search Engine Optimization (SEO)</li>
                        <li>Google Ads and Pay-Per-Click campaigns</li>
                        <li>Social Media Marketing (Facebook, Instagram, LinkedIn)</li>
                        <li>Email campaigns and retargeting strategies</li>
                        <li>Performance tracking with Google Analytics & Tag Manager</li>
                    </ul>
                </>
            ),
            image: img5,
            button: "See What We Do"
        }
    ];

    const steps = [
        {
            title: "Planning",
            desc: "Analyze client goals, gather requirements, define project scope, budget, and timeline for effective execution.",
            animation: planning,
        },
        {
            title: "Design",
            desc: "Create user-friendly layouts, wireframes, and responsive UI designs to enhance user experience and accessibility.",
            animation: design,
        },
        {
            title: "Development",
            desc: "Build the front-end and back-end systems using modern frameworks, integrate APIs, and ensure optimal performance.",
            animation: development,
        },
        {
            title: "Testing",
            desc: "Perform functional, usability, and performance testing to identify bugs, ensure quality, and enhance reliability.",
            animation: testing,
        },
        {
            title: "Launch",
            desc: "Deploy the product to a live environment, configure hosting and domains, and ensure smooth go-live operations.",
            animation: launch,
        },
        {
            title: "Maintain",
            desc: "Monitor system health, apply updates, fix issues, and scale features to support long-term success and growth.",
            animation: maintain,
        },
    ];

    return (
        <div className="page-content">
            <SEO
                title="Lavanya Infotech | Where Elegance Meets Innovation"
                description="Lavanya Infotech is a modern technology company delivering elegant and innovative IT solutions including web development, branding, UI/UX design, and digital marketing."
            />

            <Hero />

            <div className="w-full pt-5 pb-5">
                <hr className="border-t border-white opacity-200" />
            </div>

            <div className="content pt-2 sm:pt-2 md:pt-10 pb-6">
                {/* Title Section */}
                <div className="content py-10">
                    <h1 className="title font-poppins text-4xl sm:text-5xl text-center font-bold">
                        Why Choose Us ?
                        <div className="aurora">
                            <div className="aurora__item"></div>
                            <div className="aurora__item"></div>
                            <div className="aurora__item"></div>
                            <div className="aurora__item"></div>
                        </div>
                    </h1>
                </div>

                {/* Steps Section */}
                <div className="max-w-7xl xyz mx-auto w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-2 gap-x-20">
                    {steps.map((step, index) => (
                        <div
                            key={index}
                            className="flex flex-col items-center text-center justify-center h-[460px] p-4"
                        >
                            <div className="w-[260px] h-[260px] flex items-center justify-center">
                                <Lottie
                                    animationData={step.animation}
                                    loop
                                    autoplay
                                    className="w-full h-full"
                                />
                            </div>
                            <h3 className="text-2xl font-bold mt-4 font-poppins">{step.title}</h3>
                            <p className="mt-2 text-base text-gray-200 leading-relaxed max-w-xs font-inter">{step.desc}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="w-full pt-5 pb-20">
                <hr className="border-t border-white opacity-200" />
            </div>

            {/* Services Section */}
            <div className="bg-black xyz1 text-white px-4 py-2 space-y-20">
                {data.map((item, index) => (
                    <div
                        key={index}
                        className={`flex flex-col-reverse md:flex-row ${index % 2 !== 0 ? "md:flex-row-reverse" : ""
                            } items-center gap-10 max-w-7xl mx-auto`}
                    >
                        {/* Text Section */}
                        <div
                            className="w-full md:w-1/2 lg:px-6 md:px-10 md:ml-6"
                            data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
                        >
                            <h2 className="text-3xl font-bold mb-6 font-poppins text-center md:text-left">
                                {item.title}
                            </h2>
                            <div className="text-base mb-4 text-gray-200 max-w-lg leading-loose mx-auto md:mx-0 font-inter text-center md:text-left">
                                {item.desc}
                            </div>
                            <div className="md:text-left text-center mt-4">

                                <FancyButton ><Link to="/about">{item.button}</Link></FancyButton>
                            </div>
                        </div>

                        {/* Image Section */}
                        <div
                            className="w-full md:w-1/2 flex justify-center"
                            data-aos={index % 2 === 0 ? "fade-left" : "fade-right"}
                        >
                            <img
                                src={item.image}
                                alt={item.title + ' illustration'}
                                className="w-[300px] sm:w-[350px] md:w-[400px] lg:w-[400px] xl:w-[500px] h-auto object-contain transition-all duration-300 rounded-lg shadow-[0_0_20px_5px_#f6f4d2] hover:shadow-[0_0_30px_10px_#f6f4d2]"
                            />
                        </div>

                    </div>
                ))}
            </div>


            <div className="w-full pt-10 pb-5">
                <hr className="border-t border-white opacity-200" />
            </div>



            <div className="content xyz py-10">
                <h1 className="title font-poppins text-2xl sm:text-3xl text-center font-bold">
                    See What People Are Saying
                    <div className="aurora">
                        <div className="aurora__item"></div>
                        <div className="aurora__item"></div>
                        <div className="aurora__item"></div>
                        <div className="aurora__item"></div>
                    </div>
                </h1>
            </div>

            <div className="App">
                <TestimonialCarousel />
            </div>

            <div className="w-full pt-5 pb-5">
                <hr className="border-t border-white opacity-200" />
            </div>

            <div className="content  py-10">
                <h1 className="title font-poppins text-2xl sm:text-3xl text-center font-bold">
                    Discover More About What We Do
                    <div className="aurora">
                        <div className="aurora__item"></div>
                        <div className="aurora__item"></div>
                        <div className="aurora__item"></div>
                        <div className="aurora__item"></div>
                    </div>
                </h1>
            </div>

            <div className="w-full px-4 xyz1 z-10 sm:px-6 md:px-10 py-10">
                <h2 className="text-2xl sm:text-3xl text-center font-bold font-poppins">
                    Stay Updated with Lavanya Infotech 🚀
                </h2>

                <div className="flex justify-center mt-6">
                    <form
                        onSubmit={handleSubmit}
                        className="flex flex-col sm:flex-row gap-3 w-full max-w-md"
                    >
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="Enter your email"
                            className="px-4 py-2 rounded-md text-black w-full"
                        />
                        <button
                            type="submit"
                            className="px-4 py-2 bg-[#4ABEBB] text-white rounded-md hover:bg-[#3ca8a3] w-full sm:w-auto"
                        >
                            Subscribe
                        </button>
                    </form>
                </div>
            </div>

            <div className="w-full pt-5 pb-5">
                <hr className="border-t border-white opacity-200" />
            </div>

        </div >
    );
};

export default Home;
